import { Scenario } from '../types/model';

// Retain a request until the simulation route mounts (chat is available on every page).
let pending: { scenario?: Scenario } | null = null;
export function openScenarioWorkspace(scenario?: Scenario) {
  pending = { scenario };
  window.location.hash = '#/simulation';
  window.dispatchEvent(new Event('research-scenario'));
}
export function takeScenarioRequest() {
  const request = pending;
  pending = null;
  return request;
}
